// Graph values are measured telemetry, independent of uptime/status accounting.
export function aggregateTelemetrySeries(devices, originalDevices, algorithm, convertHashrate) {
  const originals = new Map((originalDevices || []).map(device => [device.id, device]));
  const buckets = new Map();
  for (const device of devices || []) {
    const original = originals.get(device.device_id);
    const unit = original?.hashrate_unit || original?.hashrateUnit || 'TH/s';
    for (const point of device.hashrate || []) {
      const time = new Date(point.created_at).getTime();
      if (!Number.isFinite(time)) continue;
      const entry = buckets.get(time) || {time: new Date(time), sum: 0, known: 0};
      const raw = point.hashrate;
      if (raw !== null && raw !== undefined && raw !== '' && Number.isFinite(Number(raw))) {
        const converted = convertHashrate(Number(raw), unit, algorithm);
        const value = converted.unit === 'GH/s' ? converted.value / 1000 : converted.value;
        if (Number.isFinite(value)) { entry.sum += value; entry.known++; }
      }
      buckets.set(time, entry);
    }
  }
  return Array.from(buckets.values()).sort((a,b) => a.time-b.time).map(entry => ({
    time: entry.time, hashrate: entry.known ? entry.sum : null,
    isNull: entry.known === 0, deviceCount: entry.known, script: algorithm,
  }));
}
